import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';

import { resetStateOnChangeOrganization } from '../auth/resetStateOnChangeOrganization';

export interface IChatState {
  unreadMessageCount: number;
  playNotificationSound: boolean;
  sendbirdAccessToken: string;
  chatError: boolean;
  membershipTokenMap: Record<string, string>;
}

export const initialState: IChatState = {
  unreadMessageCount: 0,
  playNotificationSound: false,
  sendbirdAccessToken: '',
  chatError: false,
  membershipTokenMap: {},
};

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setUnreadMessageCount: (state, action) => {
      if (action.payload > current(state).unreadMessageCount) {
        state.playNotificationSound = true;
      }
      state.unreadMessageCount = action.payload;
    },
    setPlayNotificationSound: (state, action) => {
      state.playNotificationSound = action.payload;
    },
    setSendbirdAccessToken: (state, action: PayloadAction<{
      membershipId: string,
      sendbirdAccessToken: string,
    }>) => {
      state.sendbirdAccessToken = action.payload.sendbirdAccessToken;
      if (action.payload.membershipId && action.payload.sendbirdAccessToken) {
        state.membershipTokenMap[action.payload.membershipId] = action.payload.sendbirdAccessToken;
      }
    },
    setChatError: (state, action) => {
      state.chatError = action.payload;
    },
  },
  extraReducers: (builder) => {
    const stateToReset: Partial<IChatState> = {
      ...initialState
    };
    delete stateToReset.membershipTokenMap;
    resetStateOnChangeOrganization(builder, stateToReset);
  },
});

export const {
  setUnreadMessageCount,
  setPlayNotificationSound,
  setSendbirdAccessToken,
  setChatError,
} = chatSlice.actions;
